(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.ra-customer-reviews').forEach((section, sectionIndex) => {
    if (section.dataset.raReviewReady) return;
    section.dataset.raReviewReady = 'true';
    const dialog = document.createElement('dialog');
    dialog.className = 'ra-review-dialog';
    const titleId = 'ra-full-review-' + sectionIndex;
    dialog.setAttribute('aria-labelledby', titleId);
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'ra-review-close'; close.textContent = 'Close';
    const title = document.createElement('h3'); title.id = titleId;
    const body = document.createElement('p');
    const author = document.createElement('p'); author.className = 'ra-review-author';
    dialog.append(close, title, body, author); section.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    let opener;
    dialog.addEventListener('close', () => { if (opener && opener.isConnected) opener.focus(); });
    const scan = () => {
      section.querySelectorAll('.jdgm-carousel-item').forEach(card => {
        const reviewBody = card.querySelector('.jdgm-carousel-item__review-body');
        const reviewTitle = card.querySelector('.jdgm-carousel-item__review-title');
        if (!reviewBody) return;
        let button = card.querySelector('.ra-review-more');
        if (!button) {
          button = document.createElement('button'); button.type = 'button'; button.className = 'ra-review-more'; button.textContent = 'Read full review'; button.setAttribute('aria-haspopup', 'dialog');
          const reviewer = card.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
          card.insertBefore(button, reviewer || null);
          button.addEventListener('click', event => {
            event.preventDefault(); event.stopPropagation(); opener = button;
            title.textContent = reviewTitle?.textContent.trim() || 'Customer review';
            body.textContent = reviewBody.innerText || reviewBody.textContent;
            author.textContent = card.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim() || '';
            dialog.showModal(); close.focus();
          });
        }
        const clipped = reviewBody.scrollHeight > reviewBody.clientHeight + 1 || (reviewTitle && reviewTitle.scrollHeight > reviewTitle.clientHeight + 1) || reviewBody.textContent.trim().length > 140;
        button.hidden = !clipped;
      });
    };
    let frame;
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(scan); };
    new MutationObserver(schedule).observe(section, {childList:true, subtree:true});
    new ResizeObserver(schedule).observe(section);
    document.fonts.ready.then(schedule);
    schedule();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
